<template>
    <div class="AdminImports">
        <WCard class="ImportList">
            <!--<div class="Filters flex row-stretch-center">
                <div></div>

                <ImportFilters
                    v-model="currentFilters"
                    :filters="filters"
                    @onSubmit="onSubmitImportFilters"
                    @onReset="handleResetFilters"
                />
            </div>-->

            <div class="Container flex col-center" v-if="importsFiltered.length > 0">
                <FadeTransition v-if="isLoading" mode="out-in">
                    <WLoading visible />
                </FadeTransition>
                <div v-else class="Wrapper flex-1">
                   
                    <div class="editor-container">
                        <div class="json-editor-wrapper json-editor-wrapper-nav-bar">
                            <div class="ImportList-container">
                                <ImportList :items="importsFiltered" :currentItem="currentItem" @onView="handleView" @onArchive="handleArchive"
                                    @onCancel="handleCancel" @onUnarchive="handleUnarchive" @onNewImport="handleNewImport"
                                    @onDownload="handleDownload" @onOpen="handleOpen" />
                            </div>
                            <div v-if="enablePagination" class="Pagination flex row-center">
                                <WPaginate v-if="(importsFiltered || []).length"
                                    :selected="(pagination || {}).page || 1" :pages="(pagination || {}).lastPage || 1"
                                    class="mt-1 mb-1" @onChange="handlePagination" />
                            </div>
                        </div>
                        <div class="json-editor-wrapper">
                            <div class="json-editor-wrapper-header">
                                <h4>Record on Dealcloud</h4>
                            </div>
                            <json-editor :readOnly="true" :show-btns="false" :history="false" name="DealCloud"
                                :mainMenuBar="false" :navigationBar="false" :statusBar="false" :modes="[]"
                                :value="json1" ref="editor1"></json-editor>
                        </div>
                        <div class="json-editor-wrapper">
                            <div class="json-editor-wrapper-header">
                                <h4>Record on Insight</h4>
                            </div>
                            <json-editor :readOnly="true" :show-btns="false" :history="false" name="Insight"
                                :mainMenuBar="false" :navigationBar="false" :statusBar="false" :modes="[]"
                                :value="json2" ref="editor2"></json-editor>
                        </div>
                    </div>

                    <div class="editor-container-actions flex">
                        <WButton @click="handleAccept" :disabled="!(json1 && json2)" class="ml-1">
                            Accept
                        </WButton>
                        <WButton @click="handleReject" :disabled="!(json1 && json2)" outline color="accent-blue" class="ml-1">
                            Reject
                        </WButton>
                        <WButton @click="handleDiscard" :disabled="!(json1 && json2)" outline color="accent-blue" class="ml-1">
                            Discard
                        </WButton>
                    </div>

                </div>
            </div>
            <div v-else class="Container flex col-center">
                <FadeTransition v-if="isLoading" mode="out-in">
                    <WLoading visible />
                </FadeTransition>
                <div v-else class="Wrapper flex-1">
                    <div class="no-records-container">
                        <svg class="no-records-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64">
                            <circle cx="32" cy="32" r="30" fill="none" stroke="#ccc" stroke-width="4"/>
                            <line x1="32" y1="16" x2="32" y2="36" stroke="#ccc" stroke-width="4" stroke-linecap="round"/>
                            <circle cx="32" cy="44" r="2" fill="#ccc"/>
                        </svg>
                        <p class="no-records-text">There are no records to validate.</p>
                    </div>

                </div>
            </div>
        </WCard>

        <ModalRequest :opened="modal === modals.ACCEPT" :title="$t('imports.modals.accept.text')"
            :cancelText="$t('actions.cancel')" :okText="$t('actions.confirm')" @close="handleCleanModal"
            @onAccept="confirmAccept" />

        <ModalRequest :opened="modal === modals.REJECT" :title="$t('imports.modals.reject.text')"
            :cancelText="$t('actions.cancel')" :okText="$t('actions.confirm')" @close="handleCleanModal"
            @onAccept="confirmReject" />

        <ModalRequest :opened="modal === modals.DISCARD" :title="$t('imports.modals.discard.text')"
            :cancelText="$t('actions.cancel')" :okText="$t('actions.confirm')" @close="handleCleanModal"
            @onAccept="confirmDiscard" />
    </div>
</template>

<script>
import apisauce from 'apisauce'
import {
    Api, apiRequest, rethrowError, notifySuccess, notifyError,
} from '@/api'
import { ModalRequest, Tabs, Modal } from '@/components'
import { entityMixin } from '@/mixins'
import { STATUS } from '@/entities/imports'
import fileDownload from 'js-file-download'
import { ImportList, ImportFilters, ImportForm } from './components'
import JSONEditor from 'vue-json-editor'
import { diff } from 'deep-diff'
import ApiIntegrationClient from '@/utils/apiIntegrationClient'


const MODAL_TYPES = {
    CREATE: 'CREATE',
    CANCEL: 'CANCEL',
    ARCHIVE: 'ARCHIVE',
    UNARCHIVE: 'UNARCHIVE',
}

const MODAL_TYPES_VALITADOR = {
    ACCEPT: 'ACCEPT',
    REJECT: 'REJECT',
    DISCARD: 'DISCARD',
}

const FILTERS = [
    {
        name: 'name',
        type: 'text',
        placeholder: 'Find import',
        value: '',
    },
    {
        name: 'date',
        type: 'date',
        placeholder: 'Date',
    },
]

const STATUS_FILTERS = [
    STATUS.running,
    STATUS.pendingReview,
    STATUS.completed,
    STATUS.cancelled,
    STATUS.failed,
]

const CURRENT_FILTERS = {
    name: '',
    status: '',
    date: undefined,
}

const TABS = {
    HISTORY: 'history',
}

const PER_PAGE = 20
const PAGINATION = {
    page: 1,
    perPage: PER_PAGE,
}

export default {
    name: 'AdminImports',
    components: {
        ModalRequest,
        Tabs,
        Modal,
        ImportList,
        ImportForm,
        ImportFilters,
        'json-editor': JSONEditor
    },
    mixins: [entityMixin],
    entity() {
        return {
            reload: true,
            buttons: [{
                iconLeft: 'plus-circle',
                text: this.$t('imports.addImport'),
                onClick: this.handleNewImport,
            }],
        }
    },
    metaInfo() {
        return {
            title: this.$t('admin.navigation.imports.list'),
        }
    },
    data() {
        const status = STATUS_FILTERS.map(key => ({ key, label: this.$t(`imports.status.${key}`) }))
        const filters = FILTERS.map(filter => (filter.name === 'status' ? { ...filter, options: status } : filter))
        const tabs = [
            {
                key: TABS.HISTORY,
                text: this.$t('imports.list.tabs.history'),
            },
        ]

        return {
            filters,
            currentFilters: CURRENT_FILTERS,

            tabs,
            activeTab: tabs[0].key,

            imports: undefined,
            pagination: PAGINATION,
            isLoading: false,

            selected: undefined,
            modal: undefined,
            modals: MODAL_TYPES_VALITADOR,
            isFetching: false,
            json1: null,
            json2: null,
            difference: null,
            records: [],
        }
    },
    computed: {
        breadcrumbs() {
            return [
                {
                    key: 'AdminImports',
                    label: this.$t('imports.title'),
                    to: { name: 'AdminImports' },
                },
            ]
        },
        importsFiltered() {
            return (this.imports || []).map(this.normalizeImports)
        },
        enablePagination() {
            return (this.pagination || {}).lastPage > 1
        },
        currentItem(){
            return this.selected
        }
    },
    mounted() {
        this.actions = {
            VIEW: {
                icon: 'eye',
                linkColor: 'secondary',
                disabled: false,
                event: 'onView',
                label: this.$t('imports.actions.view'),
            },
            DOWNLOAD: {
                icon: 'download',
                linkColor: 'secondary',
                disabled: false,
                event: 'onDownload',
                label: this.$t('imports.actions.download'),
            },
            ARCHIVE: {
                icon: 'save',
                linkColor: 'secondary',
                event: 'onArchive',
                label: this.$t('imports.actions.archive'),
            },
            UNARCHIVE: {
                icon: 'save',
                linkColor: 'secondary',
                event: 'onUnarchive',
                label: this.$t('imports.actions.unarchive'),
            },
            CANCEL: {
                icon: 'trash',
                linkColor: 'secondary',
                event: 'onCancel',
                label: this.$t('imports.actions.cancel'),
            },
        }

        this.fetchImports()
        const that = this;
        setTimeout(() => (that.initializeEditors()), 2000);
    },
    methods: {
        async fetchRecordsBySource(source) {
            try {
                const response = await ApiIntegrationClient.get(`/records/source/${source}`);
                this.records = response.data.data;
            } catch (error) {
                console.error('Error fetching records by source:', error);
            }
        },
        async fetchRecordsByStatus(status) {
            try {
                const response = await ApiIntegrationClient.get(`/records/status/${status}`);
                this.records = response.data.data;
            } catch (error) {
                console.error('Error fetching records by status:', error);
            }
        },
        fetchRecordsPendding() {
            try {
                const { page, perPage } = this.pagination
                
                // const response = await ApiIntegrationClient.get(`/records/pending`);
                apiRequest(ApiIntegrationClient.get(`/records/pending?page=${page}&perPage=${perPage}`), { allow: 200, rawAxiosResult:true })
                .then((response) => {
                    const data = response.data.data;
                    const meta = response.data.meta;
                    console.log(data);
                    console.log(meta);
                    this.pagination = meta
                    this.imports = data;
                    this.loadFirstRecord(data);
                })
                .catch(rethrowError(notifyError()))
                .finally(() => setTimeout(() => (this.isLoading = false), 1000))
                
                //this.records = response.data.data;
            } catch (error) {
                console.error('Error fetching records by status:', error);
            }
        },
        updateRecordStatus(id, newStatus, messageSuccess) {
            return apiRequest(ApiIntegrationClient.patch(`/records/${id}/status`, {
                status: newStatus,
            }), { allow: [204, 200, 201, 202, 203], rawAxiosResult:true }).then((response)=>{
                console.log('Record status updated successfully:', response.data);
                this.fetchImports();
                notifySuccess(messageSuccess)();
            })
            .catch(rethrowError(notifyError()))
            .finally(() => {
                this.isFetching = false
                this.handleCleanModal();
                setTimeout(() => (this.isLoading = false), 1000)
            });
        },
        initializeEditors() {
            console.log(this.$refs.editor1.editor);
            this.$refs.editor1.editor.options.history = false;
        },
        loadFirstRecord(data){
            if(data && data.length > 0){
                this.handleOpen(data[0]);
            }
        },
        handleOpen(item) {
            console.log("Open: ", item);
            this.selected = item;
            this.isLoading = true
            const that = this;
            apiRequest(ApiIntegrationClient.get(`/records/${item.id}/compare`), { allow: [204, 200, 201, 202, 203], rawAxiosResult:true })
                .then((response) => {
                    const row = response.data.data;
                    this.json1 = row.source;
                    this.json2 = row.target;

                    this.$nextTick(() => {
                        setTimeout(() => (that.compareJson(that)), 2000);
                    });
                })
                .catch(rethrowError(notifyError()))
                .finally(() => setTimeout(() => (this.isLoading = false), 1000))
        },
        compareJson(that) {
            if (that.$refs.editor1 === undefined || that.$refs.editor2 === undefined) {
                console.log("editors are undefined", that.$refs);
                return;
            }
            const json1 = this.$refs.editor1.json;
            const json2 = this.$refs.editor2.json;

            const differences = diff(json1, json2);

            this.difference = differences;
            console.log(differences, that.$refs.editor1);

            if (differences) {
                this.highlight(this.$refs.editor1, json1, differences, 'json1');
                this.highlight(this.$refs.editor2, json2, differences, 'json2');
            }
        },
        highlight(editorRef, json, differences, jsonType) {
            const jsonEditor = editorRef.editor;

            differences.forEach(d => {
                const path = d.path.join('/');
                const nodes = jsonEditor.node && jsonEditor.node.childs ? jsonEditor.node.childs.filter(n => n.field === path) : [];
                const node = nodes.length > 0 ? nodes[0] : undefined;
                if (node) {
                    node.expanded = true;
                    if (jsonType === 'json1' && (d.kind === 'E' || d.kind === 'D')) {
                        node.dom.value.classList.add('highlight-diff');
                    }
                    if (jsonType === 'json2' && (d.kind === 'E' || d.kind === 'N')) {
                        node.dom.value.classList.add('highlight-diff');
                    }
                }
            });
        },
        normalizeImports(item) {
            const {
                VIEW, CANCEL, ARCHIVE, DOWNLOAD,
            } = this.actions
            const view = ![STATUS.pending, STATUS.queued, STATUS.running].includes(item.status)
            const cancel = !![STATUS.queued, STATUS.running].includes(item.status)
            const actions = [
                ...(view ? [VIEW] : []),
                ...(cancel ? [CANCEL] : []),
                ARCHIVE,
                DOWNLOAD,
            ]

            return { ...item, actions }
        },
        handlePagination(page) {
            this.pagination = { ...this.pagination, page }
            this.fetchImports()
        },
        /** Evento que se ejecuta cuando se aplican los filtros. */
        onSubmitImportFilters() {
            // Cuando se aplica el filtro, debe volver a la primera página.
            this.pagination.page = 1
            this.fetchImports()
        },
        fetchImports() {
            const { name, status, date } = this.currentFilters
            const { page, perPage } = this.pagination
            const params = {
                ...(this.activeTab === TABS.ARCHIVE ? { archived: true } : {}),
                ...(name ? { text: name } : {}),
                ...(status ? { status } : {}),
                ...(date ? {
                    minDate: date.start,
                    maxDate: date.end,
                } : {}),
                page,
                perPage,
            }
            this.isLoading = true

            this.fetchRecordsPendding();

            
        },
        cancelImport() {
            const { id } = this.selected
            this.isFetching = true
            apiRequest(Api().imports.cancel(id))
                .then(({ data }) => {
                    notifySuccess(this.$t('imports.modals.cancelSuccess'))()
                    this.fetchImports()
                })
                .catch(rethrowError(notifyError()))
                .finally(() => {
                    this.isFetching = false
                    this.handleCleanModal()
                })
        },
        updateImport(params) {
            const { id } = this.selected
            this.isFetching = true
            apiRequest(Api().imports.update(id, params))
                .then(({ data }) => {
                    notifySuccess(this.$t('imports.modals.archiveSuccess'))()
                    this.fetchImports()
                })
                .catch(rethrowError(notifyError()))
                .finally(() => {
                    this.isFetching = false
                    this.handleCleanModal()
                })
        },
        archiveImport() {
            this.updateImport({ archived: true })
        },
        unarchiveImport() {
            this.updateImport({ archived: false })
        },
        handleResetFilters() {
            this.currentFilters = { ...CURRENT_FILTERS }
            this.fetchImports()
        },
        handleCleanModal() {
            this.modal = undefined
        },
        handleNewImport() {
            this.modal = this.modals.CREATE
        },
        handleArchive(item) {
            this.selected = item
            this.modal = this.modals.ARCHIVE
        },
        handleUnarchive(item) {
            this.selected = item
            this.modal = this.modals.UNARCHIVE
        },
        handleCancel(item) {
            this.modal = this.modals.CANCEL
        },

        async handleAccept() {
            this.modal = this.modals.ACCEPT
        },

        async confirmAccept() {
            this.isLoading = true
            await this.updateRecordStatus(this.selected.id, "VALIDATED", this.$t('imports.modals.acceptSuccess'));

        },

        async confirmReject() {
            this.isLoading = true
            await this.updateRecordStatus(this.selected.id, "REJECTED", this.$t('imports.modals.rejectSuccess'));
        },

        async confirmDiscard() {
            this.isLoading = true
            await this.updateRecordStatus(this.selected.id, "DELETED", this.$t('imports.modals.discardSuccess'));

        },

        handleReject() {
            this.modal = this.modals.REJECT
        },

        handleDiscard() {
            this.modal = this.modals.DISCARD
        },

        handleView({ id, status }) {
            if ([STATUS.completed].includes(status)) {
                this.$router.push({ name: 'AdminImportCreatePreview', params: { id } })
            } else if ([STATUS.pendingReview, STATUS.cancelled, STATUS.failed].includes(status)) {
                this.$router.push({ name: 'AdminImportsCreateValidation', params: { id } })
            }
        },
        handleCreateImport({ id, status }) {
            const name = STATUS.completed === status ? 'AdminImportCreatePreview' : 'AdminImportsGenerate'
            this.handleCleanModal()
            setTimeout(() => this.$router.push({ name, params: { id } }), 600)
        },
        /**
         * Descarga el fichero en formato xls.
         * Si no existe el fichero, muestra un error por pantalla.
         * @param {number} item Identificador del fichero.
         * @param {string} name Nombre de la importación que se utiliza para el nombre del fichero.
         */
        handleDownload({ fileUploadId, name }) {
            apiRequest(Api().imports.importDownload(fileUploadId))
                .then((res) => { fileDownload(res, `${name}.csv`) })
                .catch(rethrowError(notifyError()))
        },
    },
}
</script>

<style lang="scss" scoped>
.no-records-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    text-align: center;
}

.no-records-icon {
    fill: #ccc; /* Color del icono */
    margin-bottom: 10px; /* Espacio entre el icono y el texto */
}

.no-records-text {
    color: #666; /* Color del texto */
    font-size: 16px; /* Tamaño del texto */
}
.Container {
    position: relative;
    min-height: calc(100vh - 255px);

    .Wrapper {
        width: 100%;
    }
}

.Filters {
    padding: 15px;
}

.List {
    .ImportItem+.ImportItem {
        border-top: 1px solid $gray-05;
    }
}

.Tabs {
    height: 35px;
}

.editor-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-top: 20px;
}

.json-editor-wrapper {
    width: 45%;
    overflow: auto;
    padding: 10px;
    box-sizing: border-box;
    
    display: flex;
    flex-direction: column;
    height: 100vh;

}

.ImportList-container {
    flex-grow: 1;
    overflow-y: auto;
    height: calc(100vh - 100px); 
}

.highlight-diff {
    background-color: #ffd700 !important;
}

.json-editor-wrapper-nav-bar {
    max-width: 300px !important;
    overflow: hidden !important;
}

.editor-container-actions {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}

.json-editor-wrapper-header {
    display: flex;
}
</style>
